import { action } from 'mobx';
import agent from '../services/web/agent';

class GeneratePasswordStore {

    @action generatePasswordAction() {

        return agent.Users.generatePassword()
            .then(action((pwd) => {
                return pwd;
            }));
    };

    generatedPassword = async () => await generatePasswordAction();
}

export default new GeneratePasswordStore();
